<template>
  <div>
    <page-title :title="$t('presets.label')"/>
    <div class="l-row">
      <div class="l-col-4@md" v-if="modulesPresets.length" v-for="modulePreset in modulesPresets" :key="modulePreset">
        <preset-card :module="modulePreset"/>
      </div>
    </div>
    <panel v-if="!modulesPresets.length" class="u-textCenter">
      Nenhuma predefinição disponível para ser configurada.
    </panel>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import List from '@/components/shared/list/Paginator'
  import FormGroup from '@/components/template/FormGroup'
  import PresetCard from '@/components/presets/Card'
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'

  export default {
    data: () => ({
      modulesPresets: []
    }),
    async mounted () {
      await this.fetchPresets()
    },
    methods: {
      ...mapActions('presets', [
        'fetchPresets'
      ])
    },
    computed: {
      ...mapFields({
        presets: 'presets.presets'
      })
    },
    watch: {
      presets (value) {
        value.map(preset => {
          const moduleExist = this.modulesPresets.find(module => (
            module.from.type === preset.from.type && module.from.identifier === preset.from.identifier &&
            module.to.type === preset.to.type && module.to.identifier === preset.to.identifier
          ))

          if (moduleExist === undefined) {
            this.modulesPresets.push({
              from: {
                type: preset.from.type,
                identifier: preset.from.identifier,
                logo: preset.from.logo
              },
              to: {
                type: preset.to.type,
                identifier: preset.to.identifier,
                logo: preset.to.logo
              }
            })
          }
        })

        this.modulesPresets.map(module => {
          module.presets = []

          const presets = this.presets.filter(preset => (
            module.from.type === preset.from.type && module.from.identifier === preset.from.identifier &&
            module.to.type === preset.to.type && module.to.identifier === preset.to.identifier
          ))

          for (let i in presets) {
            const preset = presets[i]

            module.presets.push(preset)
          }
        })
      }
    },
    components: {
      List,
      FormGroup,
      PresetCard,
      PageTitle,
      Panel
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// List.vue?38fc1807